class Multicast {
  constructor() {
    this.init = false
  }
  _init = async () => {
    if (this.init) return true

    document.getElementById("player").appendChild(document.getElementById("videoplane"))
    _$.loader.createObject(
      "object",
      {
        style: "position:absolute; display:none;",
        type: "video/broadcast",
        width: "100%",
        height: "100%",
        id: "vidObject"
      },
      document.getElementById("videoplane")
    )

    this.init = true
    return true
  }

  start = async () => {
    document.getElementById("vidObject").style.display = null
    vidObject.bindToCurrentChannel()
    return true
  }
  destroy = async forceDestroy => {
    if (__.media.isPlaying() || forceDestroy) await this.stop()
    document.getElementById("vidObject").style.display = "none"

    return true
  }
  play = async () => {
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    _$.vue.$once([`event${__._api.cookies.PLAY}`, "mediaError"], payload => promise.resolve(payload))

    const uri = _$.splitUrl(__.media.getSource())

    let requestObject_ = {
      Cookie: __._api.cookies.PLAY,
      CmdType: "Change",
      Fun: "ChannelSelection",
      CommandDetails: {
        ChannelTuningDetails: { URL: `multicast://${uri.host}:${uri.port}/0/0/0` }
      }
    }
    __._api._sendCommand(requestObject_)
    vidObject.bindToCurrentChannel()

    let payload = await promise.done
    if (payload.error) return false
    else return true
  }
  stop = async () => {
    let promise = await _$.progress.create()
    _$.vue.$once([`event${__._api.cookies.STOP}`, "mediaError", "mediaStopped"], payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.STOP,
      CmdType: "Change",
      Fun: "ChannelSelection",
      CommandDetails: {
        TrickMode: "Stop"
      }
    }

    if (__._source.lastChannel) {
      requestObject_.CommandDetails["ChannelTuningDetails"] = {
        URL: __._source.lastChannel
      }
      __._source.lastChannel = null
    }

    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    _$.handler.emit("stopped")

    if (payload.error) return false
    else return true
  }
  pause = async () => {
    return false
  }
  continue = async () => {
    return false
  }

  /* Control Helpers */
  isSeekable = async () => {
    return false
  }
  getDuration = async () => {
    return false
  }
  getPosition = async () => {
    return false
  }
  setPosition = async () => {
    return false
  }

  /* Language and Subtitles Helpers */
  getSubtitles = async () => {
    const promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.SUBTITLE}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.SUBTITLE,
      CmdType: "Request",
      Fun: "Subtitles"
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return false

    const subtitles = payload.detail.SubtitleLanguageList.map(rec => {
      return {
        key: rec.SubtitleLanguageIndex || "zero",
        value: rec.Language.toString(),
        selected: rec.SubtitleLanguageIndex == payload.detail.CurrentRenderingSubtitleLanguageIndex
      }
    })

    if (subtitles.length <= 1) return false
    return subtitles
  }
  setSubtitle = async pid => {
    let requestObject_ = {
      Cookie: __._api.cookies.SUBTITLE,
      CmdType: "Change",
      Fun: "Subtitles",
      CommandDetails: { SubtitleState: "On", SubtitleLanguageIndex: pid === "zero" ? 0 : pid }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
  closeSubtitle = async () => {
    let requestObject_ = {
      Cookie: __._api.cookies.SUBTITLE,
      CmdType: "Change",
      Fun: "Subtitles",
      CommandDetails: { SubtitleState: "Off", SubtitleLanguageIndex: 0 }
    }
    __._api._sendCommand(requestObject_)
    return true
  }

  getLanguages = async () => {
    const promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.AUDIO}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.AUDIO,
      CmdType: "Request",
      Fun: "AudioLanguage"
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return false

    const languages = payload.detail.AudioLanguageList.map(rec => {
      return {
        key: rec.AudioLanguageIndex || "zero",
        value: rec.Language.toString(),
        selected: rec.AudioLanguageIndex == payload.detail.CurrentPlayingAudioLanguageIndex
      }
    })

    if (languages.length <= 1) return false
    return languages
  }
  setLanguage = async pid => {
    let requestObject_ = {
      Cookie: __._api.cookies.AUDIO,
      CmdType: "Change",
      Fun: "AudioLanguage",
      CommandDetails: {
        AudioLanguageIndex: pid === "zero" ? 0 : pid
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
}

export default Multicast
